<div class="dl-sim-toolbar">
    @if (!dlModel.fullReadonly) {
        @if (_modelleerniveau >= 40) {
            <button id="toggleSimulationModebtn"
                    class="topmenubarbtn simactie simulatiestap"
                    [class]="'topmenubarbtn simactie simulatiestap simulatiestap_' + volgendeSimStap()"
                    [title]="weergaveInstellingen.beginnersmodusAan() ? '' : (('STARTSIM_NEXTSTEP_' + volgendeSimStap()) | translate)"
                    [disabled]="modelLeeg() || volgendeSimStap() === 'finished'"
                    dlBeginnersuitleg="toggleSimulationModebtn"                    (click)="simuleer('nextstep')">
            </button>
        }
        <button id="simulationStepbtn"
                class="topmenubarbtn simactie"
                [class.simulatiestop]="simulatieAan()"
                [class.simulatievol]="!simulatieAan()"
                [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ((simulatieAan() ? 'STOPSIM' : 'SIMFULL') | translate)"
                [disabled]="modelLeeg()"
                dlBeginnersuitleg="simulationStepbtn"                (click)="simuleer('fullOrStop')">
        </button>
        <div class="topmenubardivider"></div>
        <button class="topmenubarbtn simactie sel_eind_toestanden"
                id="selectEndingsBtn"
                [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('SELECT_ENDSTATE' | translate)"
                [class.actief]="stateSelectie().endings"
                [disabled]="!simulatieAan()"
                dlBeginnersuitleg="selectEndingsBtn"                (click)="doeSim('selectEndings')">
        </button>
        <button class="topmenubarbtn simactie sel_gedragspad"
                id="selectPadBtn"
                [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('SELECT_GEDRAGSPAD' | translate)"
                [class.actief]="stateSelectie().pad"
                [disabled]="!simulatieAan()"
                dlBeginnersuitleg="selectPadBtn"                (click)="doeSim('selectPad')">
        </button>
        <button class="topmenubarbtn simactie sel_alle_toestanden"
                id="selectAllStatesBtn"
                [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('SELECT_ALLSTATES' | translate)"
                [class.actief]="stateSelectie().alles"
                [disabled]="!simulatieAan()"
                dlBeginnersuitleg="selectAllStatesBtn"                (click)="doeSim('selectAllstates')">
        </button>
        <button class="topmenubarbtn simactie sel_geen_toestanden"
                id="selectNoStatesBtn"
                [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('SELECT_NOSTATES' | translate)"
                [class.actief]="stateSelectie().niets"
                [disabled]="!simulatieAan()"
                dlBeginnersuitleg="selectNoStatesBtn"                (click)="doeSim('selectNone')">
        </button>
        <div class="topmenubarbtn-kol">
            <button id="simhistory_ineq"
                    class="topmenubarbtn smallbtn simactie simhistory_ineq"
                    [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('INEQHISTORY' | translate)"
                    [class.actief]="history().ineq"
                    [disabled]="!simulatieAan()"
                    dlBeginnersuitleg="simhistory_ineq"                    (click)="doeSim('toggleIneqHistory')">
            </button>
            <button id="simhistory_value"
                    class="topmenubarbtn smallbtn simactie simhistory_value"
                    [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('VALUEHISTORY' | translate)"
                    [class.actief]="history().value"
                    [disabled]="!simulatieAan()"
                    dlBeginnersuitleg="simhistory_value"                    (click)="doeSim('toggleValueHistory')">
            </button>
        </div>
        @if (sessie.fastestPathOverschrijfbaar()) {
            <div class="topmenubardivider"></div>
            <button class="topmenubarbtn simactie"
                    id="toggleFastestPathBtn"
                    [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ((_fastestPathAan ? 'FASTESTPATH.AAN' : 'FASTESTPATH.UIT') | translate)"
                    [class.actief]="_fastestPathAan"
                    [disabled]="!simulatieAan()"
                    dlBeginnersuitleg="toggleFastestPathBtn"                    (click)="doeSim('toggleFastestPath')">
                <i class="fa-solid fa-rocket"></i>
            </button>
        }
        <div class="topmenubardivider"></div>
        @if (sessie.magSwitchProject()) {
            <div id="switchprojectdropdown" (click)="$event.stopPropagation()">
                <button id="switchprojectbtn"
                        class="topmenubarbtn"
                        [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('BTN_SWITCHPROJECT' | translate)"
                        dlBeginnersuitleg="switchprojectbtn"                        (click)="toggleSwitchProject()">
                    <i class="fa-regular fa-folder-open"></i>
                </button>
                <div id="switchprojectlst" [class.open]="switchProjectOpen()">
                    <div class="switchproject_huidig">
                        <i class="fa-regular fa-folder-open"></i>
                        @if (metDomein()) {
                            {{sessie.domeinnaam()}} -
                        }
                        {{sessie.projectcode()}}
                    </div>
                    @for (domein of domeinen(); track domein) {
                        @if (metDomein()) {
                            <div class="switchproject_domein">
                                <i class="fa-regular fa-folder"></i> {{domein}}
                            </div>
                        }
                        @for (project of gegroepeerdeProjecten()[domein]; track project.project_id) {
                            <div class="switchproject_keuze"
                                 (click)="modelbeheer.wisselProject(project.project_id)">
                                {{project.project_code}}
                            </div>
                        }
                    }
                </div>
            </div>
        }
    }
    <button id="logoutbtn"
            class="topmenubarbtn"
            [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('BTN_LOGOUT' | translate)"
            dlBeginnersuitleg="logoutbtn"            (click)="modelbeheer.logUit()">
        <i class="fa-solid fa-right-from-bracket"></i>
    </button>
    <div class="clear"></div>
</div>
